
import Vue, { CreateElement, VNode } from "vue";
import { VSelect, VList, VListItem, VListItemTitle, VDialog, VTextField } from "vuetify/lib";

import { FormField, FormValue, ListField } from "@/types";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { getFieldProps, mergeProps } from "@/lib/helpers/fieldHelpers";

@Component({ name: "BaseSelect" })
export default class BaseSelect extends Vue {
  @Prop({ type: Object, required: true })
  public readonly field!: FormField;

  @Prop({ required: true })
  public readonly value!: FormValue;

  public dialog: boolean = false;

  private render(h: CreateElement): VNode {
    let props = getFieldProps(this.field, this.value);

    if (!this.$vuetify.breakpoint.xsOnly) {
      props = mergeProps({ menuProps: { maxHeight: 320 } }, props);
      return h(VSelect, {
        props,
        ref: "desktopSelect",
        on: { input: (v: any) => this.$emit("input", v) },
      });
    }

    props = mergeProps(
      {
        appendIcon: "arrow_drop_down",
        readonly: true,
      },
      props
    );

    props.value = (props.items.find((item: ListField) => item.value === this.value) || {}).text;

    return h(
      VDialog,
      {
        props: { value: this.dialog },
        ref: "mobileSelect",
        on: { input: (v: boolean) => (this.dialog = v) },
        scopedSlots: {
          activator: ({ on }: { on: any }) => [
            h(VTextField, {
              props,
              class: { textfield: true, _focused: this.dialog },
              on: {
                ...on,
                "click:append": () => (this.dialog = true),
                "click:clear": () => {
                  this.$emit("input", undefined);
                },
              },
            }),
          ],
        },
      },
      [
        h(VList, [
          props.items.map((item: ListField) =>
            h(
              VListItem,
              {
                props: { ...props.listTileProps, key: item.value },
                class: { "primary--text": this.value === item.value },
                on: {
                  click: () => {
                    this.$emit("input", item.value);
                    this.dialog = false;
                  },
                },
              },
              [h(VListItemTitle, item.text)]
            )
          ),
        ]),
      ]
    );
  }
}
